<template>
  <v-dialog v-model="localIsOpen" max-width="500px">
    <v-card>
      <v-card-title class="text-h5">
        Управление номерами телефонов
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="localPhoneData.phone"
          label="Номер телефона"
          outlined
          dense
        ></v-text-field>

        <v-text-field
          v-model="localPhoneData.name"
          label="Имя"
          outlined
          dense
        ></v-text-field>

        <v-checkbox
          v-model="localPhoneData.action"
          label="Добавить номер"
        ></v-checkbox>

        <v-text-field
          v-model="localPhoneData.code"
          label="Код (по умолчанию используется базовый)"
          outlined
          dense
        ></v-text-field>
        <p class="text-caption text-grey">
          Если код не указан, будет использован базовый код.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-btn color="grey" @click="$emit('close')">
          Отмена
        </v-btn>
        <v-btn color="primary" @click="saveData">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    phoneData: Object,
  },
  data () {
    return {
      localIsOpen: this.isOpen,
      localPhoneData: { ...this.phoneData },
    };
  },
  watch: {
    isOpen (val) {
      this.localIsOpen = val;
    },
    phoneData (val) {
      this.localPhoneData = { ...val };
    },
  },
  methods: {
    saveData () {
      this.$emit('save', this.localPhoneData);
    },
  },
};
</script>
